import React from 'react';

import { useAppVersionCheck } from '../../hooks/ui/useAppVersionCheck';
import { APP_VERSION_UPDATE_MESSAGE } from '../../hooks/ui/useAppVersionCheck/constants';
import { StyledBanner, StyledRefreshButton } from './styled';

export const AppVersionBanner: React.FC = () => {
  const { reloadApp, updateAvailable } = useAppVersionCheck();

  if (!updateAvailable) {
    return null;
  }

  return (
    <StyledBanner data-testid="appVersionBanner">
      <span>{APP_VERSION_UPDATE_MESSAGE}</span>
      <StyledRefreshButton data-testid="appVersionBannerRefresh" onClick={reloadApp} type="button">
        Refresh
      </StyledRefreshButton>
    </StyledBanner>
  );
};

export default AppVersionBanner;
